import { Stack } from "@mui/material";
import { type FC } from "react";

import {
  CardsCarousel,
  CardsCarouselSlide,
} from "~/components/UI/CardsCarousel";
import { EventSectionTitle } from "~/feature/event/components/EventSectionTitle";
import { RelatedEventCard } from "~/feature/relatedEvents/components/RelatedEventCard";
import type { IRelatedEvent } from "~/types/relatedEvent";

interface IRelatedEventsCarouselProps {
  header: string;
  events: IRelatedEvent[];
}

export const RelatedEventsCarousel: FC<IRelatedEventsCarouselProps> = ({
  header,
  events,
}) => {
  return (
    <Stack sx={{
      gap: 1.5
    }}>
      <EventSectionTitle>{header}</EventSectionTitle>

      <CardsCarousel>
        {events.map((event) => (
          <CardsCarouselSlide key={event.slug}>
            <RelatedEventCard event={event} />
          </CardsCarouselSlide>
        ))}
      </CardsCarousel>
    </Stack>
  );
};
